import { render, staticRenderFns } from "./cursorFollow.vue?vue&type=template&id=18a066de&"
import script from "./cursorFollow.vue?vue&type=script&lang=js&"
export * from "./cursorFollow.vue?vue&type=script&lang=js&"
import style0 from "./cursorFollow.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "cursorFollow.vue"
export default component.exports